/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Filter_ToInputs */



/**
* | output |
* | --- |
* | "To date" |
*
* @param {Promo_Ledger_Filter_ToInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_filter_to = /** @type {((inputs?: Promo_Ledger_Filter_ToInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Filter_ToInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date de fin")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha hasta")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Data final")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data di fine")
	return /** @type {LocalizedString} */ ("To date")
});